<!--  Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved. -->

<template>
	<div class="uploadComp">
		<h1>Digital Document Upload Service</h1>
		<TasUpload
			class="uploadComp__tasUpload"
			@uploadFailure="uploadFailed"
			@uploadSuccess="uploadSuccessful"
			region="NONE"
			:maxFilesize="150"
			:hideCancelButton="false"
			:isExternalCustomerView="false"
			:showOnlyMetadataProvided="false"
		/>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { actionTypes, mutationTypes } from '@/store/index';

export default {
	name: 'upload-comp',
	methods: {
		...mapActions({
			getFileTypes: actionTypes.GET_FILE_TYPES,
		}),
		...mapMutations({
			setToast: mutationTypes.SET_TOAST,
		}),
		uploadFailed(statusArray) {
			let newErrorToast = {
				color: 'red',
				timer: 600000,
				icon: 'warning_medium',
				show: true,
				text: `Error: ${statusArray[0].text}`,
			};
			if (statusArray[0].doc) {
				const failedFiles = statusArray.map((doc) => doc.doc.filename).join(', ');
				newErrorToast = {
					...newErrorToast,
					files: failedFiles,
				};
			}
			this.setToast(newErrorToast);
		},
		uploadSuccessful(statusArray) {
			const newSuccessToast = {
				color: 'green',
				timer: 5000,
				show: true,
				icon: 'description_medium',
				text: 'Uploaded Files Successfully!',
			};
			this.setToast(newSuccessToast);
		},
	},
};
</script>

<style lang="scss" scoped>
.uploadComp {
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: calc(74px + 3em) 3em 3em;

	&__tasUpload {
		width: 1050px;
	}

	h1 {
		display: flex;
		justify-content: center;
		margin-bottom: 15px;
		font-weight: 100;
		line-height: 48px;
		font-size: 36px;
		color: $primary-gray;
	}

	h2 {
		margin-bottom: 1em;
	}
}
</style>
